import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { ClipboardList, Wrench, LogOut, ExternalLink, HardHat } from "lucide-react";
import { Logo } from "../../components/Logo";
import { useAuth } from "../../lib/AuthContext";
import { NetworkStatus, InstallPrompt } from "../../components/NetworkStatus";

const navItems = [
  { to: "/team", end: true, label: "Today's jobs", icon: ClipboardList, testid: "team-nav-jobs" },
  { to: "/team/stock", label: "Stock requests", icon: Wrench, testid: "team-nav-stock" },
];

export const TeamLayout = () => {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/login", { replace: true }); };
  return (
    <div className="min-h-screen bg-[#f5f6f6] flex flex-col" data-testid="team-layout">
      <NetworkStatus />
      {/* Mobile-first header */}
      <header className="sticky top-0 z-30 bg-[#20282c] text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <Link to="/team" className="flex items-center gap-3">
            <Logo variant="group" size="sm" dark />
          </Link>
          <div className="flex items-center gap-1">
            <span className="hidden sm:inline-flex items-center gap-1 text-xs font-display uppercase tracking-widest text-[#ffc438]">
              <HardHat size={12} /> Field Team
            </span>
            <Link to="/" className="ml-2 h-9 w-9 rounded-md hover:bg-white/10 flex items-center justify-center" title="Website" data-testid="team-back-site">
              <ExternalLink size={16} />
            </Link>
            <button
              type="button"
              onClick={onLogout}
              className="h-9 w-9 rounded-md hover:bg-white/10 flex items-center justify-center"
              title="Sign out"
              data-testid="team-logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-5 pb-24">
        <Outlet />
      </main>

      {/* Bottom nav — mobile-first */}
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-white border-t border-[#cfd7db] shadow-[0_-4px_16px_rgba(0,0,0,0.05)]">
        <div className="max-w-3xl mx-auto grid grid-cols-2">
          {navItems.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `py-3 flex flex-col items-center gap-1 font-display uppercase tracking-widest text-xs transition ${
                    isActive ? "text-[#f28a16]" : "text-[#3f4b52]"
                  }`
                }
              >
                <Icon size={20} />
                {it.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
      <InstallPrompt />
    </div>
  );
};

export default TeamLayout;
